import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ResponseInterface } from '../interfaces/response';
import { Router } from '@angular/router';
import { UserType } from '../enums/constants';
import { AdminUser } from '../interfaces/AdminUser';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient, private router: Router) { }
  user: any = null;
  usertype = UserType.CONTACT;

  signIn(reqparams) {
    return this.http
      .post<any>(`/api/signin`, reqparams)
      .subscribe((res: any) => {
        this.user = res.user;
        this.usertype = this.user.usertype;
      });
  }

  validatePhoneNumber(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/validate-phone-number', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  sendTFA(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/send-tfa', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  verifyTFA(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/verify-tfa', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  contactPhoneVerify(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/contact/verify-phone-number', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  sendPhoneChangeTFA(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/send-phone-change-tfa', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  verifyPhoneChangeTFA(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/verify-phone-change-tfa', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  sendLoggedInUserTFA(responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/send-loggedin-user-tfa', {}).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  verifyLoggedInUserTFA(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/verify-loggedin-user-tfa', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  updateDetails(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/update', params).subscribe(
      (res: any) => {
        this.user = res;
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  updateProfile(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/edit-profile', params).subscribe(
      (res: any) => {
        this.user = res;
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  updateProfileContact(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/contact/edit-profile', params).subscribe(
      (res: any) => {
        this.user = res;
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  handleError(error: HttpErrorResponse) {
    if (this.router) {
      //this.router.navigate(['/login']);
    }
    console.log(this);

    if (typeof error.error === 'string') {
      return throwError(error);
    } else if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }

    //  window.location.href = "/login";
    return throwError('please try again later.');
  }

  checkWelcomeScreen() {
    return this.http.post<any>(`/api/welcome`, {}).subscribe((res: any) => { });
  }

  checkUserAuth(): Observable<any> {
    return this.http
      .get<any>('/api/auth', {})
      .pipe(catchError(this.handleError));
  }

  checkVault(): Observable<any> {
    return this.http
      .get<any>('/api/vault-check', {})
      .pipe(catchError(this.handleError));
  }

  checkSession(): Observable<any> {
    return this.http
      .get<any>('/api/session-check', {})
      .pipe(catchError(this.handleError));
  }

  openVault(reqparams): Observable<any> {
    return this.http.post<any>(`/api/vault-open`, reqparams);
  }

  closeVault(): Observable<any> {
    let route = (this.usertype === UserType.CONTACT)
      ? '/api/close-vault-for-contact'
      : '/api/vault-close';

    return this.http
      .get<any>(route, {})
      .pipe(catchError(this.handleError));
  }

  generateKeys(): Observable<any> {
    return this.http
      .get<any>('/api/vault-generate', {})
      .pipe(catchError(this.handleError));
  }

  verifyKey(params): Observable<any> {
    return this.http.post<any>(`/api/verify-vault`, params);
  }

  checkIsContactUser(params): Observable<any> {
    return this.http.post<any>('/api/user-contact-check', {});
  }

  getUserInfoForContact(params): Observable<any> {
    return this.http.post<any>('/api/contact-users', params);
  }

  generateNewKeys(params): Observable<any> {
    return this.http
      .post<any>('/api/vault-generate-new', params)
      .pipe(catchError(this.handleError));
  }

  remvoeNewKeys(): Observable<any> {
    return this.http
      .post<any>('/api/vault-remove-new', {})
      .pipe(catchError(this.handleError));
  }

  removeFromVerification(params): Observable<any> {
    return this.http
      .post<any>('/api/remove-from-verification', params)
      .pipe(catchError(this.handleError));
  }

  acceptParticipation(params): Observable<any> {
    return this.http
      .post<any>('/api/accept-participation', params)
      .pipe(catchError(this.handleError));
  }

  verifyDeath(params): Observable<any> {
    return this.http
      .post<any>('/api/verify-death', params)
      .pipe(catchError(this.handleError));
  }

  openVaultForContact(params): Observable<any> {
    return this.http
      .post<any>('/api/open-vault-for-contact', params)
      .pipe(catchError(this.handleError));
  }

  sessionUpdate(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/session-update', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  requestEmailPhoneChange(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/request-email-phone-change', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  resendEmailPhoneChange(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/resend-email-phone-change', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  cancelEmailPhoneChange(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/cancel-email-phone-change', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  cancelPhoneChangeByToken(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/cancel-phone-change-token', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getPhoneChangeDetailsByToken(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/get-phone-change-token', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  acceptPhoneChangeByToken(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/accept-phone-change-token', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  refuteDeath(responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/refuted-death', {}).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  deathRefuteByContact(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/contact-refute-death', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  setDoNotShowDownloadModal(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/do-not-show-download-modal', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getAuthSessionUserData(params, responseInterface: ResponseInterface<any>) {
    return this.http.get<any>('/api/auth', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getCurrentUserOrContact(params, responseInterface: ResponseInterface<any>) {
    return this.http.get<any>('/api/get-current-user-or-contact', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  updateUserDiscountCode(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/update-user-discount-code', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getVaultUserForContact(responseInterface: ResponseInterface<any>) {
    return this.http.get<any>('/api/get-vault-user-for-contact').subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getAuthAdmin() {
    return this.http.get<{ data: AdminUser }>("/api/admin/auth");
  }

  getAssociatedContactActsForContact(responseInterface: ResponseInterface<{ data: string[] }>) {
    return this.http.get<{ data: string[] }>('/api/get-associated-contact-acts-for-contact').subscribe(
      (res: { data: string[] }) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  setReportedDeathWaitTime(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/user/reported-death-wait-time', params).subscribe(
      (res: any) => {
        this.user = res;
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
}
